import React from 'react';

const Help = () => (
  <div>
    <div>
      <span>Use the following commands to navigate the app</span>
    </div>
    <div>
      <span>
        <code>ls</code>
        <span>- to see the contents of current directory</span>
      </span>
    </div>
    <div>
      <span>
        <code>cd &lt;directory name&gt;</code>
        <span>- to change directory</span>
      </span>
    </div>
    <div>
      <span>
        <code>cat &lt;file name&gt;</code>
        <span>- to view contents of file</span>
      </span>
    </div>
    <div>
      <span>
        <code>pwd</code>
        <span>- to see current working directory</span>
      </span>
    </div>
    <div>
      <span>
        <code>clear</code>
        <span>- to clear your console</span>
      </span>
    </div>
  </div>
);


export default Help;
